const ArticleOverview = React.lazy(() => import("@components/ArticleOverview/ArticleOverview"));
const ButtonCollection = React.lazy(() => import("@components/ButtonCollection/ButtonCollection"));
const CourseOverview = React.lazy(() => import("@components/Course/CourseOverview/CourseOverview"));
const EventOverview = React.lazy(() => import("@components/Event/EventOverview/EventOverview"));
const FileImpression = React.lazy(() => import("@components/FileImpression/FileImpression"));
const FormAssemblyBlock = React.lazy(() => import("@components/FormAssemblyBlock/FormAssemblyBlock"));
const JMCAudioCard = React.lazy(() => import("@components/JMCAudioCard/JMCAudioCard"));
import { JMCButton } from "@components/JMCButton/JMCButton";
import { JMCCallout } from "@components/JMCCallout/JMCCallout";
import { JMCCard } from "@components/JMCCard/JMCCard";
import { JMCCarousel } from "@components/JMCCarousel/JMCCarousel";
import { JMCHero } from "@components/JMCHero/JMCHero";
import { JMCHtml } from "@components/JMCHtml/JMCHtml";
import { JMCLink } from "@components/JMCLink/JMCLink";
import { JMCTabs } from "@components/JMCTabs/JMCTabs";
const MaterialOverview = React.lazy(() => import("@components/Material/MaterialOverview/MaterialOverview"));
const MediaOverview = React.lazy(() => import("@components/MediaOverview/MediaOverview"));
const Pdf = React.lazy(() => import("@components/Pdf/Pdf"));
const PodcastOverview = React.lazy(() => import("@components/PodcastOverview/PodcastOverview"));
const ProductOverview = React.lazy(() => import("@components/ProductOverview/ProductOverview"));
const PubmedSearch = React.lazy(() => import("@components/PubmedSearch/PubmedSearch"));
const ReferenceCard = React.lazy(() => import("@components/ReferenceCard/ReferenceCard"));
const ScientificPublicationOverview = React.lazy(
    () => import("@components/ScientificPublicationOverview/ScientificPublicationOverview"),
);
import { PropTypes as VideoPlayerProps } from "@components/VideoPlayer/VideoPlayer";
const VideoPlayer = React.lazy(() => import("@components/VideoPlayer/VideoPlayer"));
import { useAccessLevel } from "@contexts";
import analyticstracker from "@jmc/analyticstracker";
import { AccordionPaneImpression } from "@jmc/core/src/components/AccordionImpression";
import { CardImpression } from "@jmc/core/src/components/CardImpression/index";
import { FileDownloadImpression } from "@jmc/core/src/components/FileDownloadImpression/index";
import Iframe from "@jmc/core/src/components/Iframe/iframe";
const Locator = React.lazy(() => import("@jmc/core/src/components/Locator/Locator"));
const MediaImpression = React.lazy(() => import("@jmc/core/src/components/MediaImpression/MediaImpression"));

import { FaqBlock } from "@components/FaqBlock/FaqBlock";
import { OneTrustWebForm } from "@components/OneTrustWebForm/OneTrustWebForm";
import { TabImpression } from "@jmc/core/src/components/TabImpression/index";
import { useLocale } from "@jmc/core/src/hooks/useLocale/index";
import { EventTypes } from "@jmc/core/src/types/EventTypes";
import { FlexibleGrid } from "@jmc/solid-design-system/src/components/atoms/FlexibleGrid/FlexibleGrid";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { Accordion } from "@jmc/solid-design-system/src/components/molecules/Accordion/Accordion";
import { AudioCardPreview } from "@jmc/solid-design-system/src/components/molecules/AudioCard/AudioCardPreview";
import { Tabs } from "@jmc/solid-design-system/src/components/molecules/Tabs/Tabs";
import { Image, ImageWrapper } from "@jmc/solid-design-system/src/components/organisms/Image/Image";
import { Gallery } from "@jmc/solid-design-system/src/components/organisms/ImageGallery/ImageGallery";
import { BrightcovePreview } from "@jmc/solid-design-system/src/components/organisms/VideoPlayer/Brightcove/BrightcovePreview";
import { VideoPlayerGallery } from "@jmc/solid-design-system/src/components/organisms/VideoPlayerGallery/VideoPlayerGallery";
import { BreakPoint, useMediaQuery } from "@jmc/solid-design-system/src/hooks/useMediaQuery/useMediaQuery";
import { getLanguage } from "@jmc/solid-design-system/src/utils/languages";
import urlHelper from "@jmc/solid-design-system/src/utils/url-helper";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import { cleanCSSIdentifier } from "@jmc/utils/utils/clean-css-identifier";
import { default as fileHelper } from "@jmc/utils/utils/file-helper";
import { ApplicationState } from "@redux/modules";
import { Profile } from "@redux/modules/profile";
import {
    AccessLevel,
    CMSAccordionPane,
    CMSArticleOverviewProps,
    CMSAudioProps,
    CMSBlock,
    CMSButtonCollectionProps,
    CMSCardProps,
    CMSCarouselProps,
    CMSCourseOverviewProps,
    CMSEventOverviewProps,
    CMSFootnotes,
    CMSFormAssemblyProps,
    CMSHeroProps,
    CMSMaterialOverviewProps,
    CMSMediaGalleryProps,
    CMSMediaOverviewProps,
    CMSOnetrustFormProps,
    CMSPdfViewerProps,
    CMSPodcastOverviewProps,
    CMSProductOverviewProps,
    CMSProductProps,
    CMSPubmedSearchProps,
    CMSScientificPublicationOverviewProps,
    CMSTabPane,
    CMSTabsProps,
} from "@types";
import { CombinedCvent } from "@types";
import { default as cmsMapper } from "@utils/cms-mapper";
import { default as eventHelper } from "@utils/event-helper";
import { default as getBlockType } from "@utils/getBlockType";
import classnames from "classnames";
import { GatsbyImage } from "gatsby-plugin-image";
import isEqual from "lodash/isEqual";
import React, { Suspense, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AccordionPane, CMSAccordionProps } from "types/CMSAccordionProps";
import { CMSFaqProps } from "types/CMSFaqProps";
import { CMSIframeProps } from "types/CMSIframeProps";
import { CMSMapProps } from "types/CMSMapProps";

import { ImageFitType } from "../../../../design_system/src/components/organisms/Image/Image";
import { CMSImageGalleryImage, CMSImageGalleryProps } from "../../types/CMSImageGalleryProps";
import style from "./style.module.scss";

interface PropTypes {
    relatedProduct?: CMSProductProps;
    content: CMSBlock;
    footnotes: CMSFootnotes[];
    noBottomSpacing?: boolean;
    smallerFullWidthHeroes?: boolean;
    index: number;
    sectionBackground?: string;
    sectionIndex?: number;
    placement: string;
    position?: number;
    hash?: string;
    dropShadow?: boolean;
    addBorder?: boolean;
    cvents?: CombinedCvent[];
    flexibleColumnHeight?: boolean;
    noTopPaddingFirstSection?: boolean;
}

const spaceRegex = /[ "]/gm;
const textDataTestId = (input: string): string => {
    const clean = input?.replace(spaceRegex, "");
    return clean?.slice(0, clean.length > 10 ? 10 : clean.length);
};

/**
 * A Block container is responsible for instantiating the correct React component based on the Block type received from the CMS.
 */
export const Block = (props: PropTypes): JSX.Element => {
    const { t } = useTranslation();
    const locale = useLocale();
    const isMobile = useMediaQuery(BreakPoint.md);
    const {
        relatedProduct,
        content,
        footnotes,
        noBottomSpacing = false,
        smallerFullWidthHeroes = false,
        placement,
        index,
        position = 1,
        sectionBackground = null,
        sectionIndex = 0,
        hash,
        dropShadow = true,
        addBorder = false,
        cvents = [],
        flexibleColumnHeight = false,
        noTopPaddingFirstSection = false,
    } = props;

    const blockType = getBlockType(content);
    const accessLevel = useAccessLevel();
    const { jnjFullBranded } = useJnjBranding();

    switch (blockType) {
        case "accordion": {
            const { accordion } = content;

            return (
                <div className={style.accordion_group}>
                    {accordion.panes.map(({ pane }: CMSAccordionPane, index: number) => {
                        return (
                            <div key={index} className={style.accordion}>
                                <AccordionPaneImpression name={pane.title} open={pane.open}>
                                    <Accordion
                                        id={pane.title || index.toString()}
                                        open={pane.open}
                                        backgroundColor="white"
                                        autoId={cleanCSSIdentifier(`pane-title-${pane?.title?.toLocaleLowerCase()}`)}
                                        title={<JMCHtml footnotes={footnotes}>{pane.title}</JMCHtml>}
                                    >
                                        <div className={style.content}>
                                            {pane.content &&
                                                pane.content.map((block: CMSBlock, i: number) => (
                                                    <div key={i}>
                                                        <Block
                                                            relatedProduct={relatedProduct}
                                                            content={block}
                                                            footnotes={footnotes}
                                                            index={index}
                                                            placement={`${placement}:${pane.title}`}
                                                            position={i + 1}
                                                            hash={hash}
                                                            sectionBackground={sectionBackground}
                                                            sectionIndex={sectionIndex}
                                                            cvents={cvents}
                                                        />
                                                    </div>
                                                ))}
                                        </div>
                                    </Accordion>
                                </AccordionPaneImpression>
                            </div>
                        );
                    })}
                </div>
            );
        }
        case "button": {
            const { button } = content;
            return (
                <div className={style.button}>
                    <JMCButton
                        button={button}
                        {...(jnjFullBranded && isMobile && { fullWidth: true })}
                        placement={placement}
                        footnotes={footnotes}
                    />
                </div>
            );
        }
        case "button_collection": {
            const buttonCollectionProps: CMSButtonCollectionProps = content?.button_collection;
            const buttons =
                content?.button_collection?.buttons?.length &&
                content?.button_collection?.buttons.map((button) => button.button);
            return (
                <Suspense fallback={<div id={`suspense-div-${index}-button_collection`} />}>
                    <div className={style.buttonContainer}>
                        <ButtonCollection
                            buttons={buttons}
                            horizontal_alignment={buttonCollectionProps?.horizontal_alignment}
                        />
                    </div>
                </Suspense>
            );
        }
        case "component": {
            const component = content?.component?.component?.[0];
            const componentType = component?.internal?.type?.replace("Contentstack_component_", "");
            switch (componentType) {
                case "accordion": {
                    const accordionProps = cmsMapper.mapAccordionProps(component as CMSAccordionProps);
                    const paneUpdate = (anchor: string): AccordionPane[] => {
                        return anchor
                            ? accordionProps.panes.map((pane, index) => {
                                  const anchors = accordionProps.anchors.find((a) => a.pane === index);
                                  const includesHash =
                                      anchors.my_anchors.indexOf(anchor) >= 0 ||
                                      anchors.sub_anchors?.indexOf(anchor) >= 0;
                                  return includesHash ? { ...pane, pane: { ...pane.pane, open: true } } : pane;
                              })
                            : accordionProps.panes;
                    };
                    const checkPanelForFootnote = (footnoteIndex: number): AccordionPane[] => {
                        const relevantText = footnotes?.find((footnote) =>
                            footnote.footnotes.find((f) => f.index === footnoteIndex),
                        )?.text;
                        return footnoteIndex
                            ? accordionProps.panes.map((pane: CMSAccordionPane) => {
                                  const includesFootnote = pane?.pane?.content?.find((c) => {
                                      return c.text?.textual_content == relevantText;
                                  });
                                  return includesFootnote ? { ...pane, pane: { ...pane.pane, open: true } } : pane;
                              })
                            : accordionProps.panes;
                    };
                    const [panes, updatePanes] = React.useState<AccordionPane[]>(paneUpdate(hash));

                    useEffect(() => {
                        const eventFunct = (e: CustomEventInit): void => {
                            if (!e.detail) {
                                /* eslint-disable no-console */
                                console.error("Missing anchor");
                                return;
                            }
                            if (e?.detail?.isFootnote) {
                                updatePanes(checkPanelForFootnote(e.detail?.index));
                            } else {
                                updatePanes(paneUpdate(e.detail));
                            }
                        };
                        document.addEventListener("recalc", eventFunct);
                        return (): void => {
                            document.removeEventListener("recalc", eventFunct);
                        };
                    }, []);

                    const toggleVisibility = (id: number): void => {
                        const updatedPanes = panes.map((pane, index) => {
                            return index === id ? { ...pane, pane: { ...pane.pane, open: !pane.pane.open } } : pane;
                        });
                        updatePanes(updatedPanes);
                    };

                    return (
                        <div className={style.accordion_group}>
                            {accordionProps?.showTitle && (
                                <Typography data-test-id="Accordion.Title2" variant="h3">
                                    <JMCHtml footnotes={footnotes}>{accordionProps?.title}</JMCHtml>
                                </Typography>
                            )}
                            {panes.map((pane: CMSAccordionPane, index: number) => {
                                const titleWithoutFootnotes =
                                    footnotes?.find((footnote) => footnote.text === pane.pane.title)
                                        ?.text_without_footnotes || pane.pane.title;
                                return (
                                    <div key={`${index}-${titleWithoutFootnotes}`} className={style.accordion}>
                                        <AccordionPaneImpression name={titleWithoutFootnotes} open={pane.pane.open}>
                                            <Accordion
                                                onClick={toggleVisibility}
                                                id={String(index)}
                                                open={pane.pane.open}
                                                backgroundColor="white"
                                                autoId={cleanCSSIdentifier(
                                                    `pane-title-${titleWithoutFootnotes.toLocaleLowerCase()}`,
                                                )}
                                                title={<JMCHtml footnotes={footnotes}>{pane.pane.title}</JMCHtml>}
                                                dataTestId={`Accordion.${titleWithoutFootnotes}`}
                                            >
                                                <div className={style.content}>
                                                    {pane.pane.content &&
                                                        pane.pane.content.map((block: CMSBlock, i: number) => (
                                                            <Block
                                                                relatedProduct={relatedProduct}
                                                                key={`${placement}:${titleWithoutFootnotes}:${i + 1}`}
                                                                content={block}
                                                                footnotes={footnotes}
                                                                index={index}
                                                                placement={`${placement}:${titleWithoutFootnotes}`}
                                                                position={i + 1}
                                                                hash={hash}
                                                                sectionBackground={sectionBackground}
                                                                sectionIndex={sectionIndex}
                                                                cvents={cvents}
                                                            />
                                                        ))}
                                                </div>
                                            </Accordion>
                                        </AccordionPaneImpression>
                                    </div>
                                );
                            })}
                        </div>
                    );
                }
                case "article_overview": {
                    const articleOverviewProps = cmsMapper.mapArticleOverview(component as CMSArticleOverviewProps);
                    return (
                        <div className={classnames(style.vertical_margins, style.topMargin)}>
                            <Suspense fallback={<div id={`suspense-div-${index}-article_overview`} />}>
                                <ArticleOverview
                                    {...articleOverviewProps}
                                    placement={`${placement}:${articleOverviewProps.title}`}
                                    footnotes={footnotes}
                                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                                />
                            </Suspense>
                        </div>
                    );
                }
                case "card": {
                    const cardProps = cmsMapper.mapCardProps(component as CMSCardProps, jnjFullBranded);
                    const link = cmsMapper.getLink(cardProps?.buttons[0]?.link_group);
                    const { url, external } = link;
                    const isPhoneNumberUrl = url?.startsWith("tel");
                    let targetUrl = url && urlHelper.getFullUrl(url, locale, external);
                    targetUrl = isPhoneNumberUrl ? `callto phone-number` : targetUrl;

                    const card = (
                        <JMCCard
                            cardProps={cardProps}
                            footnotes={footnotes}
                            placement={placement}
                            sectionIndex={sectionIndex}
                        />
                    );

                    return (
                        <div className={classnames(style.vertical_margins, style.fill_container)}>
                            <CardImpression
                                type={`general`}
                                name={(cardProps?.title as string) || component.title}
                                placement={`${placement}|card:(${cardProps?.title?.toString().toLowerCase()})`}
                                position={position}
                                targeturl={targetUrl}
                            >
                                {card}
                            </CardImpression>
                        </div>
                    );
                }
                case "carousel": {
                    const carouselProps = cmsMapper.mapCarouselProps(component as CMSCarouselProps);
                    return (
                        <JMCCarousel
                            {...carouselProps}
                            placement={placement}
                            footnotes={footnotes}
                            loading={sectionIndex === 0 ? "eager" : "lazy"}
                            fullWidth={jnjFullBranded ? false : carouselProps?.fullWidth}
                        />
                    );
                }
                case "course_overview": {
                    const courseOverviewProps = cmsMapper.mapCourseOverview(component as CMSCourseOverviewProps);
                    return (
                        <div className={classnames(style.vertical_margins, style.topMargin)}>
                            <Suspense fallback={<div id={`suspense-div-${index}-course_overview`} />}>
                                <CourseOverview
                                    {...courseOverviewProps}
                                    placement={`${placement}:${courseOverviewProps.title}`}
                                    footnotes={footnotes}
                                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                                />
                            </Suspense>
                        </div>
                    );
                }
                case "event_overview": {
                    const eventOverviewProps = cmsMapper.mapEventOverview(component as CMSEventOverviewProps);

                    return (
                        <div
                            className={classnames(style.vertical_margins, style.topMargin)}
                            data-test-id={`Block.EventOverview.${eventOverviewProps.id}`}
                        >
                            <Suspense fallback={<div id={`suspense-div-${index}-event_overview`} />}>
                                <EventOverview
                                    {...eventOverviewProps}
                                    placement={`${placement}:${eventOverviewProps.title}`}
                                    footnotes={footnotes}
                                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                                    cvents={cvents}
                                />
                            </Suspense>
                        </div>
                    );
                }
                case "faq": {
                    const { accordion, accordion_content, display_options, display_title, text_content, title } =
                        component as CMSFaqProps;
                    return (
                        <FaqBlock
                            content={accordion ? accordion_content : text_content}
                            placement={placement}
                            title={display_options?.show_title ? display_title || title : null}
                            sectionIndex={index}
                            footnotes={footnotes}
                            jnjFullBranded={jnjFullBranded}
                        />
                    );
                }
                case "formassembly": {
                    const { title, confirmed_compliance, source } = component as CMSFormAssemblyProps;
                    return (
                        confirmed_compliance && (
                            <Suspense fallback={<div id={`suspense-div-${index}-formassembly`} />}>
                                <FormAssemblyBlock
                                    title={title}
                                    formAssemblyRestUrl={source}
                                    compliance={confirmed_compliance}
                                />
                            </Suspense>
                        )
                    );
                }
                case "hero": {
                    const { ...heroProps } = jnjFullBranded
                        ? cmsMapper.mapCalloutProps(component as CMSHeroProps)
                        : cmsMapper.mapHeroProps(component as CMSHeroProps);
                    const height = eventHelper.getHeightSize(heroProps?.heroHeight || "auto");

                    return jnjFullBranded ? (
                        <div data-test-id="HeroComponent" className={classnames(style.hero, style.hero__full_width)}>
                            <JMCCallout
                                {...heroProps}
                                footnotes={footnotes}
                                placement={placement}
                                loading={sectionIndex === 0 ? "eager" : "lazy"}
                            />
                        </div>
                    ) : (
                        <div
                            data-test-id="HeroComponent"
                            className={classnames(
                                style.hero,
                                heroProps.fullWidth &&
                                    (smallerFullWidthHeroes ? style.hero__small_full_width : style.hero__full_width),
                            )}
                        >
                            <JMCHero
                                hero={component}
                                height={height}
                                footnotes={footnotes}
                                placement={placement}
                                loading={sectionIndex === 0 ? "eager" : "lazy"}
                            />
                        </div>
                    );
                }
                case "iframe": {
                    const iframe = component as CMSIframeProps;
                    const profile = useSelector(
                        (state: ApplicationState) => state.profile?.data as unknown as Profile,
                        isEqual,
                    );
                    let userInfo = null;
                    if (iframe?.pass_parameters && profile) {
                        const { codsId, email, firstName, lastName } = profile;
                        userInfo = { codsId, email, name: firstName, surname: lastName, locale };
                    }

                    // Please avoid using React.lazy to load the iframe component as it causes issues with anchor scrolling
                    return iframe.compliance_analysis_approved ? (
                        <div id="iframeSizeContainer" data-test-id="Iframe.Container">
                            <Iframe
                                src={iframe.url}
                                visualSegregation={iframe.visual_segregation}
                                height={iframe?.iframe_size?.value ?? undefined}
                                unit={iframe?.iframe_size?.unit ?? undefined}
                                options={{ scrolling: !iframe.hide_scrollbars }}
                                text={t(
                                    "common:An inpage-modal to tell the user that the iFrame is not part of the Janssen owned compliance analyses",
                                )}
                                userInfo={userInfo}
                            />
                        </div>
                    ) : (
                        <p>{`Compliance Analysis not approved for an iframe with the url ${component.url}.`}</p>
                    );
                }
                case "image_gallery": {
                    const { display_title, display_options } = component as CMSImageGalleryProps;
                    const enableLightBox =
                        display_options?.enable_lightbox !== null ? display_options?.enable_lightbox : true;

                    return (
                        <div className={style.vertical_margins}>
                            {display_options?.show_display_title && (
                                <div className={style.titleVerticalMargin}>
                                    <Typography variant="h3" id="imageGalleryTitle">
                                        <JMCHtml footnotes={footnotes}>{display_title}</JMCHtml>
                                    </Typography>
                                </div>
                            )}
                            <Gallery enableLightBox={enableLightBox}>
                                {component.gallery_content.images.map((image: CMSImageGalleryImage, index: number) => {
                                    const imageData = image?.gatsbyImageData;

                                    return (
                                        <GatsbyImage
                                            image={imageData}
                                            key={index}
                                            alt={image?.description || ""}
                                            title={image?.title}
                                            style={{ width: "100%", height: "200px" }}
                                            loading={sectionIndex === 0 ? "eager" : "lazy"}
                                        />
                                    );
                                })}
                            </Gallery>
                        </div>
                    );
                }
                case "map": {
                    const locatorProps = cmsMapper.mapLocatorProps(component as CMSMapProps);
                    return (
                        <div className={classnames(style.vertical_margins, style.topMargin)}>
                            <Suspense fallback={<div id={`suspense-div-${index}-map`} />}>
                                <Locator
                                    name={component?.title?.replace(/ /g, "")}
                                    component={JMCLink}
                                    placement={placement}
                                    indexLocation={`${process.env.GATSBY_SEARCH_REGION} - Maps`}
                                    {...locatorProps}
                                />
                            </Suspense>
                        </div>
                    );
                }
                case "material_overview": {
                    const materialOverviewProps = cmsMapper.mapMaterialOverview(component as CMSMaterialOverviewProps);
                    return (
                        <div
                            className={style.vertical_margins}
                            style={
                                jnjFullBranded
                                    ? {
                                          "--card-background-color":
                                              sectionBackground === "gray" ? "var(--white)" : "var(--background-04)",
                                      }
                                    : null
                            }
                        >
                            <MaterialOverview
                                {...materialOverviewProps}
                                footnotes={footnotes}
                                locale={locale}
                                loading={sectionIndex === 0 ? "eager" : "lazy"}
                            />
                        </div>
                    );
                }
                case "media_gallery": {
                    const { display_title, display_options } = component as CMSMediaGalleryProps;
                    const { show_publication_date, show_imr_code, show_download_link } = display_options;
                    return (
                        <div className={style.vertical_margins}>
                            {display_options?.show_display_title && (
                                <div className={style.titleVerticalMargin}>
                                    <Typography variant="h3" id="mediaGalleryTitle">
                                        <JMCHtml footnotes={footnotes}>{display_title}</JMCHtml>
                                    </Typography>
                                </div>
                            )}
                            <VideoPlayerGallery>
                                {component.gallery_content.media_types.map((player, index: number) => {
                                    const isAudioAsset = player?.media_source === "asset";
                                    return (
                                        <Suspense
                                            key={index}
                                            fallback={
                                                <div id={`suspense-div-player-gallery-${index}`}>
                                                    {player?.media_source === "asset" ? (
                                                        <AudioCardPreview />
                                                    ) : (
                                                        <BrightcovePreview thumbnail={player?.poster_image?.url} />
                                                    )}
                                                </div>
                                            }
                                        >
                                            <MediaImpression
                                                id={
                                                    isAudioAsset
                                                        ? player.uid
                                                        : player.video_id?.toString() || player.audio_id?.toString()
                                                }
                                                type={player.video_id?.length ? "video" : "audio"}
                                                name={player.title}
                                                placement={`VideoPlayerGallery:(${index})`}
                                                position={index + 1}
                                                player={player.media_source}
                                                mediasource={player.media_source}
                                                thresholdvalue={0.5}
                                                fillParentContainerVertically={true}
                                            >
                                                {player?.media_source === "asset" ? (
                                                    <JMCAudioCard
                                                        audio={player as CMSAudioProps}
                                                        showImr={show_imr_code}
                                                        showDownloadLink={show_download_link}
                                                        showPublicationDate={show_publication_date}
                                                    />
                                                ) : (
                                                    <VideoPlayer
                                                        provider={
                                                            player?.media_source.toLowerCase() as VideoPlayerProps["provider"]
                                                        }
                                                        videoId={player.video_id || player.audio_id}
                                                        schemaTitle={
                                                            component.display_options.show_display_title
                                                                ? player.title
                                                                : null
                                                        }
                                                        schemaSummary={player?.summary}
                                                        updated_at={player?.updated_at}
                                                        thumbnail={player?.poster_image?.url}
                                                    />
                                                )}
                                            </MediaImpression>
                                        </Suspense>
                                    );
                                })}
                            </VideoPlayerGallery>
                        </div>
                    );
                }
                case "media_overview": {
                    const mediaOverviewProps = cmsMapper.mapMediaOverview(component as CMSMediaOverviewProps);
                    return (
                        <div className={style.vertical_margins}>
                            <Suspense fallback={<div id={`suspense-div-${index}-media_overview`} />}>
                                <MediaOverview
                                    {...mediaOverviewProps}
                                    placement={`${placement}:${mediaOverviewProps.title}`}
                                    footnotes={footnotes}
                                    locale={locale}
                                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                                />
                            </Suspense>
                        </div>
                    );
                }
                case "onetrust_form": {
                    const onetrustWebformProps = cmsMapper.mapOnetrustWebForm(component as CMSOnetrustFormProps);
                    return (
                        <div className={style.onetrustContainer}>
                            <OneTrustWebForm {...onetrustWebformProps} />
                        </div>
                    );
                }
                case "pdf_viewer": {
                    const {
                        title,
                        pdf_file,
                        pdf_title,
                        pdf_source = "File asset",
                        external_link,
                        downloadable,
                    } = component as CMSPdfViewerProps;
                    return (
                        <Suspense fallback={<div id={`suspense-div-${index}-pdf-viewer`} />}>
                            <FileImpression name={pdf_file?.filename || pdf_title} type="pdf">
                                <Pdf
                                    fileTitle={pdf_title || title}
                                    fileUrl={pdf_source !== "External" ? pdf_file?.url : external_link}
                                    downloadable={downloadable}
                                />
                            </FileImpression>
                        </Suspense>
                    );
                }
                case "podcast_overview": {
                    const podCastOverviewProps = cmsMapper.mapPodcastOverview(component as CMSPodcastOverviewProps);
                    return (
                        <div className={classnames(style.vertical_margins, style.topMargin)}>
                            <Suspense fallback={<div id={`suspense-div-${index}-podcast_overview`} />}>
                                <PodcastOverview placement={placement} {...podCastOverviewProps} />
                            </Suspense>
                        </div>
                    );
                }
                case "product_overview": {
                    const productOverviewProps = cmsMapper.mapProductOverview(component as CMSProductOverviewProps);
                    return (
                        <div className={style.vertical_margins}>
                            <Suspense fallback={<div id={`suspense-div-${index}-product_overview`} />}>
                                <ProductOverview
                                    {...productOverviewProps}
                                    footnotes={footnotes}
                                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                                />
                            </Suspense>
                        </div>
                    );
                }
                case "pubmed_search": {
                    const pubmedSearchProps = cmsMapper.mapPubmedSearch(component as CMSPubmedSearchProps);
                    return (
                        <div className={classnames(style.vertical_margins, style.topMargin)}>
                            <Suspense fallback={<div id={`suspense-div-${index}-pubmed_search`} />}>
                                <PubmedSearch {...pubmedSearchProps} />
                            </Suspense>
                        </div>
                    );
                }
                case "reference_card": {
                    const pureContent = component.pure_content?.[0];
                    const type = pureContent?.internal?.type?.replace("Contentstack_", "");
                    if (pureContent?.order_copies?.delivery_method === "salesrep") {
                        return null;
                    }

                    return (
                        <div className={classnames(style.vertical_margins, style.topMargin, style.fill_container)}>
                            <Suspense fallback={<div id={`suspense-div-${index}-reference_card`} />}>
                                <ReferenceCard
                                    {...{ content: pureContent, type: type }}
                                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                                    cvents={cvents}
                                    placement={placement}
                                    position={position}
                                />
                            </Suspense>
                        </div>
                    );
                }
                case "scientific_publication_overview": {
                    const scientificPublicationOverviewProps = cmsMapper.mapScientificPublicationOverview(
                        component as CMSScientificPublicationOverviewProps,
                    );
                    return (
                        <div className={classnames(style.vertical_margins, style.topMargin)}>
                            <Suspense fallback={<div id={`suspense-div-${index}-scientific_publication_overview`} />}>
                                <ScientificPublicationOverview
                                    {...scientificPublicationOverviewProps}
                                    placement={`${placement}:${scientificPublicationOverviewProps.title}`}
                                    footnotes={footnotes}
                                    locale={locale}
                                    loading={sectionIndex === 0 ? "eager" : "lazy"}
                                />
                            </Suspense>
                        </div>
                    );
                }
                case "tab": {
                    const tabProps = cmsMapper.mapTabProps(component as CMSTabsProps);
                    const checkTabForHash = (anchor: string): number => {
                        const index =
                            anchor &&
                            tabProps.panes.findIndex((_: CMSTabPane, index: number) => {
                                const anchors = tabProps.anchors.find((a) => a.pane === index);
                                return (
                                    anchors.my_anchors.indexOf(anchor) >= 0 || anchors.sub_anchors?.indexOf(anchor) >= 0
                                );
                            });
                        return anchor && index !== -1 ? index : null;
                    };
                    const checkTabForFootnote = (footnoteIndex: number): number => {
                        const relevantText = footnotes?.find((footnote) =>
                            footnote.footnotes.find((f) => f.index === footnoteIndex),
                        )?.text;
                        const index =
                            footnoteIndex &&
                            tabProps.panes.findIndex((_: CMSTabPane) => {
                                return _?.pane?.content?.find((c) => {
                                    return c.text?.textual_content == relevantText;
                                });
                            });

                        return index !== -1 ? index : null;
                    };
                    const [hasHashInPane, updateHasHashInPanex] = React.useState<number>(checkTabForHash(hash));

                    useEffect(() => {
                        const eventFunct = (e: CustomEventInit): void => {
                            if (!e.detail) {
                                /* eslint-disable no-console */
                                console.error("Missing anchor");
                                return;
                            }
                            if (e?.detail?.isFootnote) {
                                updateHasHashInPanex(checkTabForFootnote(e.detail?.index));
                            } else {
                                updateHasHashInPanex(checkTabForHash(e?.detail));
                            }
                        };
                        document.addEventListener("recalc", eventFunct);
                        return (): void => {
                            document.removeEventListener("recalc", eventFunct);
                        };
                    }, []);

                    return (
                        <>
                            {tabProps?.showTitle && (
                                <Typography data-test-id={`Tabs.Title`} variant="h3">
                                    <JMCHtml footnotes={footnotes}>{tabProps?.title}</JMCHtml>
                                </Typography>
                            )}
                            <JMCTabs
                                selectedTab={hasHashInPane}
                                onChange={(index: number, e: React.MouseEvent) => {
                                    updateHasHashInPanex(index);
                                    analyticstracker().trackInteraction(e, {
                                        changeEvent: EventTypes.TAB_CLICK,
                                        addData: {
                                            info: {
                                                name: tabProps.panes[index].pane.title,
                                                position: index + 1,
                                                placement,
                                                state:
                                                    hasHashInPane === 0 || index === 0
                                                        ? "auto-visible"
                                                        : "click-visible",
                                            },
                                        },
                                    });
                                }}
                                sectionBackground={sectionBackground}
                            >
                                {tabProps.panes.map((tab: CMSTabPane, index: number) => {
                                    const titleWithoutFootnotes =
                                        footnotes?.find((footnote) => footnote.text === tab.pane.title)
                                            ?.text_without_footnotes || tab.pane.title;
                                    return (
                                        <Tabs.Tab
                                            key={`${titleWithoutFootnotes}-${index}`}
                                            title={<JMCHtml footnotes={footnotes}>{tab.pane.title}</JMCHtml>}
                                            autoId={cleanCSSIdentifier(
                                                `pane-title-${titleWithoutFootnotes.toLocaleLowerCase()}`,
                                            )}
                                        >
                                            <TabImpression.Content
                                                key={`${titleWithoutFootnotes}-content-${index}`}
                                                placement={placement}
                                                position={index + 1}
                                                name={titleWithoutFootnotes}
                                                open={hasHashInPane === 0 || index === 0}
                                            >
                                                <div className={style.tabContent}>
                                                    {tab.pane?.content?.map((block: CMSBlock, i: number) => (
                                                        <div
                                                            className={style.tabContainer}
                                                            key={`tab-${titleWithoutFootnotes}-${index}`}
                                                        >
                                                            <Block
                                                                relatedProduct={relatedProduct}
                                                                content={block}
                                                                footnotes={footnotes}
                                                                index={index}
                                                                placement={`${placement}:${titleWithoutFootnotes}`}
                                                                position={i + 1}
                                                                hash={hash}
                                                                sectionBackground={sectionBackground}
                                                                sectionIndex={sectionIndex}
                                                                cvents={cvents}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </TabImpression.Content>
                                        </Tabs.Tab>
                                    );
                                })}
                            </JMCTabs>
                        </>
                    );
                }
                default:
                    return componentType ? (
                        <p>{`${componentType} component is not yet defined.`}</p>
                    ) : (
                        <p>Component not published? componentType is undefined.</p>
                    );
            }
        }
        case "flexible_row": {
            const { flexible_row } = content;

            return (
                <FlexibleGrid
                    spacing={jnjFullBranded && !isMobile ? 32 : 24}
                    fractions={flexible_row.columns.map(({ column }) => column.width || 1)}
                    noTopSpacing={jnjFullBranded}
                >
                    {flexible_row.columns.map(({ column }, col: number) => (
                        //This div is needed because we need a wrapper for content of the column to apply the fractions correctly in the flexible grid
                        <span
                            data-test-id={`${placement}:row-${index}:col-${col}`}
                            key={`${placement}:row-${index}:col-${col}`}
                            style={{
                                display: "flex",
                                justifyContent: column?.v_align || "flex-top",
                                alignItems: column?.h_align || "stretch",
                                flexDirection: "column",
                            }}
                            className={style.flexibleRowBlocks}
                        >
                            {column.content.map((content: CMSBlock, i: number) => (
                                <Block
                                    relatedProduct={relatedProduct}
                                    key={`${placement}:row-${index}:col-${col}:block-${i}`}
                                    content={content}
                                    footnotes={footnotes}
                                    index={col}
                                    position={i + 1}
                                    placement={`${placement}:row-${index}:col-${col}`}
                                    hash={hash}
                                    sectionBackground={sectionBackground}
                                    sectionIndex={sectionIndex}
                                    cvents={cvents}
                                    flexibleColumnHeight={true}
                                />
                            ))}
                        </span>
                    ))}
                </FlexibleGrid>
            );
        }
        case "fragment": {
            const {
                fragment: { fragment, reference },
            } = content;
            // Check if the fragment uses the unique identifier "fragment" (most cases) or "reference" (fragments in a Tab)
            const tmpFragment = reference ? reference : fragment;
            return (
                <>
                    {tmpFragment?.length &&
                        tmpFragment[0].body.map((item, index) => {
                            // 2 consecutive sections with the same background color should not have the double spacing in between
                            const noBottomSpacing =
                                !!tmpFragment[0].body[index + 1] &&
                                tmpFragment[0].body[index + 1].section?.background_color ===
                                    item.section?.background_color;
                            return (
                                <Block
                                    relatedProduct={relatedProduct}
                                    key={index}
                                    content={item}
                                    footnotes={footnotes}
                                    noBottomSpacing={noBottomSpacing}
                                    index={index}
                                    placement={`${placement}:tmpFragment`}
                                    position={index + 1}
                                    hash={hash}
                                    smallerFullWidthHeroes={smallerFullWidthHeroes}
                                    sectionBackground={sectionBackground}
                                    sectionIndex={sectionIndex}
                                    cvents={cvents}
                                />
                            );
                        })}
                </>
            );
        }
        case "image": {
            const { imageProps, link, fileUrl } = cmsMapper.mapImageProps(content.image, locale);

            const imageData = imageProps?.image?.gatsbyImageData;
            const scaleDown = imageProps?.fit?.toLowerCase() === "scale-down";
            const dimension = imageProps?.image?.dimension;

            const ImgStyle = scaleDown
                ? {
                      width: "100%",
                      maxWidth: `${dimension?.width}px`,
                      maxHeight: `${dimension?.height}px`,
                  }
                : undefined;

            // if image fit is set to scale-down than either of start | end | center | not-scale-down is passed as centerAlign parameter based on horizontal Alignment Property.
            const objecthorizontalAlignment = scaleDown
                ? imageProps?.horizontal_alignment?.toLowerCase()
                : "not-scale-down";

            const objectFit = imageProps?.fit?.toLowerCase();

            // images that are supported by gatsby's image plugin and sharp will have a localAsset, others (e.g. svgs and gifs) will not
            const ImgComponent = imageData ? (
                <ImageWrapper
                    sizing={ImgStyle}
                    enableLightBox={imageProps?.enable_lightbox}
                    id={`Image.${imageProps?.alt_text}`}
                    caption={
                        imageProps?.caption ? <JMCHtml footnotes={footnotes}>{imageProps?.caption}</JMCHtml> : null
                    }
                    horizontalAlignment={objecthorizontalAlignment}
                    url={imageProps?.image?.url}
                    enlargeLabel={t("Enlarge image", { ns: "common" })}
                >
                    <GatsbyImage
                        image={imageData}
                        alt={imageProps?.alt_text || imageProps?.image?.description || ""}
                        title={imageProps?.title || imageProps?.alt_text}
                        imgStyle={{ objectFit: objectFit || "cover" }}
                        loading={sectionIndex === 0 ? "eager" : "lazy"} // If the image is within the first section, we load the image eagerly
                    />
                </ImageWrapper>
            ) : (
                // svgs and gifs
                <Image
                    url={imageProps?.image?.url}
                    enableLightBox={imageProps?.enable_lightbox}
                    alt={imageProps?.alt_text || imageProps?.image?.description}
                    title={imageProps?.title || imageProps?.alt_text}
                    caption={
                        imageProps?.caption ? <JMCHtml footnotes={footnotes}>{imageProps?.caption}</JMCHtml> : null
                    }
                    fit={(objectFit || "cover") as ImageFitType}
                    dimension={imageProps?.image?.dimension}
                    horizontalAlignment={objecthorizontalAlignment}
                    sizing={ImgStyle}
                    loading={"eager"}
                    enlargeLabel={t("Enlarge image", { ns: "common" })}
                />
            );

            if (imageProps?.enable_lightbox) {
                return (
                    <div className={style.image} data-test-id="lightboximage">
                        {ImgComponent}
                    </div>
                );
            } else if (fileUrl) {
                return (
                    <div className={style.image} data-test-id="downloadimage">
                        <FileDownloadImpression name={fileHelper.getFileName(fileUrl)}>
                            <JMCLink
                                params={link?.params}
                                url={link.url}
                                commercial={link.commercial}
                                external={link.external}
                                fullWidth={true}
                                anchor_id={link?.anchor_id}
                                isFileAsset={link?.isFileAsset}
                            >
                                {ImgComponent}
                            </JMCLink>
                        </FileDownloadImpression>
                    </div>
                );
            }
            return (
                <div className={style.image} data-test-id="linkimage">
                    {link.url || link?.anchor_id ? (
                        <JMCLink
                            params={link?.params}
                            url={link.url}
                            commercial={link.commercial}
                            external={link.external}
                            fullWidth={true}
                            anchor_id={link?.anchor_id}
                            name={imageProps?.title || imageProps?.alt_text || imageProps?.image?.title}
                            placement={placement}
                            imageLink
                            isFileAsset={link?.isFileAsset}
                        >
                            {ImgComponent}
                        </JMCLink>
                    ) : (
                        ImgComponent
                    )}
                </div>
            );
        }
        case "player": {
            const {
                player: { show_publication_date, show_imr_code, show_download_link, use_videoid },
            } = content;
            const media = content?.player?.media?.[0];
            const playerTitle = media?.display_title ? media?.display_title : media?.title;
            const mediaId =
                media && "video_id" in media
                    ? media?.video_id
                    : media && "audio_id" in media
                      ? media?.audio_id
                      : media?.uid;
            const isAudioAsset = media?.media_source === "asset";

            return media ? (
                <div className={classnames(isAudioAsset ? style.audio_player : style.player)}>
                    <Suspense
                        fallback={
                            isAudioAsset ? (
                                <AudioCardPreview />
                            ) : (
                                <BrightcovePreview thumbnail={media?.poster_image?.url} />
                            )
                        }
                    >
                        <MediaImpression
                            id={isAudioAsset ? media?.uid : mediaId?.toString()}
                            type={media && "video_id" in media ? "video" : "audio"}
                            name={media?.title}
                            placement={`${placement}|card:(${media?.title?.toString().toLowerCase()})`}
                            position={position}
                            targeturl={null}
                            mediasource={media?.media_source}
                            player={media?.media_source}
                            thresholdvalue={0.5}
                            fillParentContainerVertically={flexibleColumnHeight ? true : false}
                        >
                            {isAudioAsset ? (
                                <JMCAudioCard
                                    audio={media as unknown as CMSAudioProps}
                                    showImr={show_imr_code}
                                    showDownloadLink={show_download_link}
                                    showPublicationDate={show_publication_date}
                                    dropShadow={dropShadow}
                                    addBorder={addBorder}
                                />
                            ) : (
                                <VideoPlayer
                                    provider={media?.media_source.toLowerCase() as VideoPlayerProps["provider"]}
                                    videoId={mediaId.toString()}
                                    thumbnail={media?.poster_image?.url}
                                    seoTitle={"seo_settings" in media ? media.seo_settings?.title : media.title}
                                    considerFluidStyle
                                    updated_at={media?.updated_at}
                                    schemaTitle={playerTitle}
                                    schemaSummary={media?.summary}
                                    useVideoId={use_videoid}
                                />
                            )}
                        </MediaImpression>
                    </Suspense>
                </div>
            ) : (
                <p>Video Not Published</p>
            );
        }
        case "section": {
            const { section } = content;
            // intended to compare localeDefaultRTLTextDir with == using type differences
            const localeDefaultTextDirection =
                locale && getLanguage(locale.split("-").shift())?.dir == 0 ? "rtl" : "ltr";

            const sectionProps = cmsMapper.mapSection(section, localeDefaultTextDirection);

            // hide section padding when the first block is a full width hero and the section title is hidden
            const firstComponent = section?.content?.[0]?.component?.component?.[0];
            const firstComponentType = firstComponent?.internal?.type?.replace("Contentstack_component_", "");
            //TODO: can probably be replaced by pure css with :has selector
            const noPadding =
                !sectionProps.showTitle &&
                firstComponentType === "hero" &&
                (firstComponent as CMSHeroProps)?.display_options?.full_width &&
                sectionProps.backgroundColor === (firstComponent as CMSHeroProps)?.display_options?.background_color;
            const anchorId = sectionProps.anchorId ? sectionProps.anchorId : sectionProps.title;
            const id = cleanCSSIdentifier(anchorId);

            // if section has audience(s) applied
            const hasAudiences = !!sectionProps?.audiences?.length;
            const additionalPropsRelatedToAudiences: { "data-audiences"?: string; "data-nosnippet"?: string } = {};
            if (hasAudiences) {
                // add the data-audiences attribute with the ids of the audience(s)
                additionalPropsRelatedToAudiences["data-audiences"] = sectionProps.audiences
                    .map((audience) => audience.id)
                    .join(" ");
            }
            // if the audience(s) applied to the section are all hidden by default (in other words, none are shown by default) ...
            const shouldBeHiddenByDefault =
                hasAudiences && !sectionProps.audiences.some((audience) => audience.shouldBeShownByDefault);
            if (shouldBeHiddenByDefault) {
                // ...add the data-nosnippet attribute
                additionalPropsRelatedToAudiences["data-nosnippet"] = ""; // Any attribute with an empty string will render into the DOM without a value. (ref: https://www.w3.org/TR/html5/syntax.html#elements-attributes)
            }

            return (
                <section
                    className={classnames(
                        style.section,
                        noPadding && style.section__nopadding,
                        noBottomSpacing && style.section__nobottompadding,
                        noTopPaddingFirstSection && index === 0 && style.section__notoppadding,
                        style[sectionProps.backgroundColor],
                        style[sectionProps.textDirection],
                        hasAudiences && shouldBeHiddenByDefault && style.section__hidden,
                    )}
                    id={id}
                    data-test-id={id}
                    data-audiences={additionalPropsRelatedToAudiences["data-audiences"]}
                    data-nosnippet={additionalPropsRelatedToAudiences["data-nosnippet"]}
                >
                    {sectionProps.showTitle && (
                        <div className={jnjFullBranded ? style.sectionTitle : style.textPrimaryColor}>
                            <Typography
                                variant="h2"
                                color="inherit"
                                id="sectionTitle"
                                data-test-id="sectionTitle"
                                data-rebranded={jnjFullBranded}
                            >
                                <JMCHtml footnotes={footnotes}>{sectionProps.title}</JMCHtml>
                            </Typography>
                        </div>
                    )}

                    <div>
                        {section.content.map((c: CMSBlock, index: number) => (
                            <Block
                                relatedProduct={relatedProduct}
                                key={`${sectionProps.title}-${index}`}
                                content={c}
                                footnotes={footnotes}
                                position={index + 1}
                                index={index}
                                placement={`${placement ?? ""}${placement ? ":" : ""}${sectionProps.title}`}
                                hash={hash}
                                sectionBackground={sectionProps?.backgroundColor}
                                sectionIndex={sectionIndex}
                                cvents={cvents}
                            />
                        ))}
                    </div>
                </section>
            );
        }
        case "tabs": {
            const { tabs } = content;

            return (
                <div className={style.vertical_margins}>
                    <JMCTabs
                        onChange={(index: number, e: React.MouseEvent) => {
                            analyticstracker().trackInteraction(e, {
                                changeEvent: EventTypes.TAB_CLICK,
                                addData: {
                                    info: {
                                        name: tabs.panes[index].pane.title,
                                        position: index,
                                        placement,
                                        state: index === 0 ? "auto-visible" : "click-visible",
                                    },
                                },
                            });
                        }}
                    >
                        {tabs.panes.map(({ pane }: CMSTabPane, index: number) => (
                            <Tabs.Tab
                                key={pane.title}
                                title={
                                    <JMCHtml footnotes={footnotes} placement={placement}>
                                        {pane.title}
                                    </JMCHtml>
                                }
                                autoId={cleanCSSIdentifier(`pane-title-${pane?.title?.toLocaleLowerCase()}`)}
                            >
                                <TabImpression.Content
                                    key={`${pane.title}-${index}`}
                                    placement={placement}
                                    position={index}
                                    name={pane.title}
                                    open={index === 0}
                                >
                                    <div className={style.tabContent}>
                                        {pane?.content?.map((block: CMSBlock, i: number) => (
                                            <Block
                                                relatedProduct={relatedProduct}
                                                key={i}
                                                content={block}
                                                footnotes={footnotes}
                                                index={index}
                                                placement={`${placement}:${pane.title}`}
                                                position={i + 1}
                                                hash={hash}
                                                sectionBackground={sectionBackground}
                                                sectionIndex={sectionIndex}
                                                cvents={cvents}
                                            />
                                        ))}
                                    </div>
                                </TabImpression.Content>
                            </Tabs.Tab>
                        ))}
                    </JMCTabs>
                </div>
            );
        }
        case "text": {
            const { text } = content;

            const textStyle = text?.automatic_columns_division
                ? { columnWidth: `${text?.automatic_columns_division?.toString()}ch` }
                : { columnCount: text?.number_of_columns || 1 }; //added fallback to the fallback in preparation for the deletion of the number of columns field in the cms

            return (
                <div
                    style={textStyle}
                    className={classnames(
                        style.text,
                        !jnjFullBranded &&
                            relatedProduct &&
                            accessLevel &&
                            accessLevel !== AccessLevel.level1 &&
                            style.text__primary,
                    )}
                    data-test-id={`Block.Text.${textDataTestId(text.textual_content)}`}
                >
                    <JMCHtml
                        footnotes={footnotes}
                        placement={placement}
                        margins={true}
                        linkManagement={text.link_management}
                        imageLoading={sectionIndex === 0 ? "eager" : "lazy"}
                        useLargeText={jnjFullBranded}
                    >
                        {text.textual_content}
                    </JMCHtml>
                </div>
            );
        }
        default:
            return <p>{`${blockType} is not defined.`}</p>;
    }
};
